import { Component, h } from 'preact';
import { VowelsApp } from './vowelsapp';
import { PageAnimator } from './pageanimator';


export class App extends Component {
    navigator: PageAnimator
    vowelsApp: VowelsApp

    constructor() {
        super()
        this.navigator = null;
    }

    componentDidMount() {
        this.vowelsApp = new VowelsApp()
        this.vowelsApp.onNavigateCallback = (newEl, direction) => this.navigator.animateToElement(newEl, direction)
        this.vowelsApp.launch();
    }

    componentWillUnmount() {
        this.vowelsApp.onNavigateCallback = null;
        this.vowelsApp = null;
    }

    render(_props?: any) {
        return (
            <PageAnimator ref={(nav) => this.navigator = nav} initialEl={null}>
            </PageAnimator>
        )
    }
}